<mat-nav-list>
  <a
    mat-list-item
    *ngFor="let thread of (threads$ | async)?.data; trackBy: trackByThread"
    [routerLink]="openThreadInDialog ? null : [messagesRoute, thread.uuid]"
    routerLinkActive
    #rla="routerLinkActive"
    [activated]="rla.isActive"
    (click)="threadClick($event, thread)"
    class="!px-0"
  >
    <app-messages-thread-list-item [thread]="thread" [selected]="rla.isActive"></app-messages-thread-list-item>
  </a>
</mat-nav-list>
